import React from 'react';
import { useDispatch } from 'react-redux';
import { DeleteProjectAction } from '../../../redux/actions/project';

import { CardStyle } from './style';

export default function Card({ list }) {
  const dispatch = useDispatch();

  const handleDeleteProject = () => {
    dispatch(DeleteProjectAction(list._id));
  };

  return (
    <CardStyle status={list.status}>
      <h3>
        {list.monthName}/{list.year}
      </h3>
      <p>
        Status: <strong>{list.status ? 'Concluído' : 'Incompleto'}</strong>
      </p>
      <p>
        Sincroniza Educação:{' '}
        <strong>{list.totalValueCnpj1.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</strong>
      </p>
      <p>
        Sincroniza Projetos:{' '}
        <strong>{list.totalValueCnpj2.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</strong>
      </p>
      <p>
        Total:
        <strong> {list.totalValue.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</strong>
      </p>
      <p>
        Ultima atualização: <strong>{list.updatedAt.substring(0, 10).split('-').reverse().join('/')}</strong>
      </p>
      <div>
        {!list.status && <a href={`sincroniza-nfe/editar-faturamento/${list._id}`}>Editar</a>}
        {!list.status && <button onClick={handleDeleteProject}>Apagar</button>}
      </div>
    </CardStyle>
  );
}
